getBaseNewRelicData